import {
    ButtonFixedFooterLayout,
    ButtonPrimary,
    Text3,
    ButtonSecondary,
    ButtonLink,
    Text2,
    Text4,
    skinVars,
    useDialog,
    IconInformationUserRegular,
} from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import './index.scss';
import { updateCustomerAgreement } from '../../../services/CustomerService';
import { isWebviewAndroid, isWebviewIOS } from '../../../utils/navigation/controlDevices';
import { TrackingEvents } from '../../../utils/dataTransformation/tracking';

const CustomerAgreement: React.FC = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { t } = useTranslation();
    const { trackingScreenView } = new TrackingEvents();
    const [windowWidth, setWindowWidth] = useState<any>(window.innerWidth);
    const { dialog } = useDialog();

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const sendToNative = (param: any) => {
        const url = param;
        navigate(url);
    };

    const updateAgreementAction = (accept: boolean) => {
        const contactSessionId = state.contactSessionId;
        updateCustomerAgreement(contactSessionId, accept).finally(() => sendToNative('/obd/verify'));
    };

    return (
        <div
            className='c-customer-agreement'
            style={{
                borderLeft: windowWidth >= 1024 ? `24px solid ${skinVars.colors.backgroundSkeleton}` : 'none',
                borderRight: windowWidth >= 1024 ? `24px solid ${skinVars.colors.backgroundSkeleton}` : 'none',
            }}
        >
            <div
                className='c-customer-agreement__header-navigationBar'
                style={{
                    background: skinVars.colors.navigationBarBackground,
                    height: isWebviewAndroid || isWebviewIOS ? '44px' : windowWidth >= 1024 ? '80px' : '56px',
                }}
            >
                {(isWebviewAndroid || isWebviewIOS) && (
                    <Text4 regular color={skinVars.colors.textNavigationBarPrimary}>
                        {t('profileAgreementAlertTitle')}
                    </Text4>
                )}
            </div>

            <ButtonFixedFooterLayout
                button={
                    <ButtonPrimary
                        onPress={() => {
                            updateAgreementAction(true);
                        }}
                    >
                        {t('profileAgreementButtonYes')}
                    </ButtonPrimary>
                }
                secondaryButton={
                    <ButtonSecondary
                        onPress={() => {
                            updateAgreementAction(false);
                        }}
                    >
                        {t('profileAgreementButtonNo')}
                    </ButtonSecondary>
                }
            >
                <div className='c-customer-agreement__wrapper'>
                    <div className='c-customer-agreement__wrapper__title'>
                        <Text3 regular color={skinVars.colors.textPrimary}>
                            {t('profileAgreementTitle')}
                        </Text3>
                    </div>
                    <div className='c-customer-agreement__wrapper__subtitle'>
                        <Text2 regular color={skinVars.colors.textSecondary}>
                            {t('profileAgreementSubtitle')}
                        </Text2>
                    </div>
                    <div className='c-customer-agreement__wrapper__buttonLink'>
                        <ButtonLink
                            onPress={() => {
                                dialog({
                                    icon: <IconInformationUserRegular color={skinVars.colors.brand} size={64} />,
                                    title: t('profileAgreementAlertTitle'),
                                    message: t('profileAgreementAlertSubtitle'),
                                    acceptText: t('got_it'),
                                    onAccept() {},
                                });
                            }}
                        >
                            {t('profileAgreementButtonLink')}
                        </ButtonLink>
                    </div>
                </div>
            </ButtonFixedFooterLayout>
        </div>
    );
};

export default CustomerAgreement;
